/*
 * � 2020 Microsoft. All rights reserved.
 */

define('MenuUI/ClassicGameTile',['pixi', 'absolute', 'lodash', 'Solitaire/SolitaireGameMode', 'MenuUI/MenuTile'],

    function (PIXI, Absolute, _, SolitaireGameMode, MenuTile) {

        var ClassicGameTile = function (config, mainMenu, callback) {
            var defaultConfig = {
                fontSize: 35
            };
            this.callback = callback;
            this.initClassicGameTile(_.extend(defaultConfig, config), mainMenu);
        };

        ClassicGameTile.prototype = Object.create(MenuTile.prototype);

        ClassicGameTile.prototype.initClassicGameTile = function (config, mainMenu) {
            this.mainMenu = mainMenu;
            if(Absolute.Platform.isMobile()){
                config.fontSize = 45;
            }
            config.letterStyle = {
                font: 'bold ' + Absolute.ScreenMetrics.getResScale() * config.fontSize + "px Arial",
                fontFamily: 'segoeLight',
                fill: '#ffffff',
                align: 'left',
                strokeThickness: 0
            };
            MenuTile.call(this, config);
            this.mainMenu = mainMenu;
            this.interactive = false;
        };

        ClassicGameTile.prototype.handleClick = function () {
            if(this.callback) this.callback.call();
            this.mainMenu.game.startGame(SolitaireGameMode[this.config.mode]);
        };

        return ClassicGameTile;

    });

